import { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { ItemTypes } from './ItemTypes.js'
import {Image, Label, Segment, Icon, Grid, Header, Popup } from 'semantic-ui-react';

const style = {
  backgroundColor: 'white',
  cursor: 'move',
}
export const Card = ({ id, description, text, titulo,index, moveCard, activo, onShowModal, handleClick, onVisible, onAcordionModulo, onEliminarModulo}) => {
  const ref = useRef(null)
  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
  })
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return { id, index }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const opacity = isDragging ? 0 : 1
  drag(drop(ref))
  return (
    <div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
                <Segment ribbon style={{ background: "#B8D8D5"}} >
                       <Grid>
                            <Grid.Row columns="2" >
                            <Grid.Column width="13"  only='computer tablet '>
                                <Label as='a' onClick={()=>onAcordionModulo(id)} color='teal' ribbon size="big">
                                  {titulo}
                                </Label>    

                                <br/><br/>

                                <Header as='h5' floated='left'>
                                    {description}
                                    <Header.Subheader>
                                        {/*contenido.length*/} actividades
                                    </Header.Subheader>
                                </Header>

                            </Grid.Column>

                            <Grid.Column width="13"  only='mobile'>
                                <Label as='a' onClick={()=>onAcordionModulo(id)}  color='teal' ribbon size="medium">
                                    {titulo}
                                </Label>    

                                <br/><br/>

                                <Header  floated='left'>
                                    {description}
                                    <Header.Subheader>
                                        {/*contenido.length*/} actividades
                                    </Header.Subheader>
                                </Header>

                            </Grid.Column>               
                            <Grid.Column width="3" textAlign='right' verticalAlign="middle">
                                <Popup
                                    trigger={
                                        <Icon size="large" color="red"  name="trash" link onClick={()=>onEliminarModulo(id)}/>
                                    }
                                    content='Eliminar'
                                />  
                                <Popup
                                trigger={        
                                    <Icon size="large" color="green"  name="pencil" link onClick={()=>onShowModal("Modulo",1,id)}/>    
                                }
                                    content='Editar'
                                />
                                <Popup
                                trigger={
                                    <Icon size="large" color={activo?"grey":"teal"}  name={activo?"minus":"plus"} link onClick={()=>onAcordionModulo(id)}/>
                                }
                                    content='Expander'
                                />    
                            </Grid.Column>

                        </Grid.Row>
                     </Grid>
                </Segment>
      
      
    </div>
  )
}
